import MenuBar from "../Component/MenuBar";
import PageBanner from '../Component/PageBanner';
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";
import './EventDetail.css';

const NavadhaBhakti = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* Page Banner */}
            <PageBanner title="Dussehra Special: Navadha Bhakti" />

            <div className="event-detail-container">
                <div className="event-detail-grid">
                    {/* Left Column - Event Info */}
                    <div className="event-info-column">
                        <div className="event-header">
                            <span className="event-category">Discourse Series</span>
                            <h1 className="event-title">Dussehra Special: Navadha Bhakti</h1>
                            <p className="event-subtitle">A Special Discourse Series with Gopeshwari Didi Ji</p>
                        </div>

                        {/* Quick Info Cards */}
                        <div className="event-quick-info">
                            <div className="info-card">
                                <i className="fa fa-calendar"></i>
                                <div>
                                    <span className="info-label">Dates</span>
                                    <span className="info-value">October 14-20, 2026 (7 Days)</span>
                                </div>
                            </div>
                            <div className="info-card">
                                <i className="fa fa-clock"></i>
                                <div>
                                    <span className="info-label">Time</span>
                                    <span className="info-value">7:00 PM - 8:30 PM Daily</span>
                                </div>
                            </div>
                            <div className="info-card">
                                <i className="fa fa-map-marker-alt"></i>
                                <div>
                                    <span className="info-label">Venue</span>
                                    <span className="info-value">Yugal Kunj, Duluth, GA</span>
                                </div>
                            </div>
                            <div className="info-card highlight">
                                <i className="fa fa-users"></i>
                                <div>
                                    <span className="info-label">Welcome</span>
                                    <span className="info-value">Everyone Is Welcome</span>
                                </div>
                            </div>
                        </div>

                        {/* Event Description */}
                        <div className="event-section">
                            <h3 className="section-title">About the Discourse Series</h3>
                            <p className="event-description">
                                Join Gopeshwari Didi Ji this Dussehra for a special discourse series on 
                                <strong> Navadha Bhakti</strong> - the 9 forms of devotion taught in the Ramayan by Lord Ram. 
                                Experience inspiring discourses, reflection and devotion each evening of this sacred week.
                            </p>
                        </div>

                        {/* Event Highlights */}
                        <div className="event-section">
                            <h3 className="section-title">Series Highlights</h3>
                            <ul className="highlights-list">
                                <li><i className="fa fa-check-circle"></i>Daily Discourses on the 9 Forms of Devotion</li>
                                <li><i className="fa fa-check-circle"></i>Teachings from the Ramayan</li>
                                <li><i className="fa fa-check-circle"></i>Inspiring Talks by Gopeshwari Didi Ji</li>
                                <li><i className="fa fa-check-circle"></i>Reflection & Devotion</li>
                                <li><i className="fa fa-check-circle"></i>7-Day Series (October 14-20)</li>
                            </ul>
                        </div>

                        {/* Action Buttons */}
                        <div className="event-actions">
                            <a
                                href="https://maps.google.com/?q=2769+Duluth+Hwy,+Duluth,+GA+30096"
                                target="_blank"
                                rel="noreferrer"
                                className="btn-primary"
                            >
                                <i className="fa fa-map-marker-alt"></i> Get Directions
                            </a>
                            <a
                                href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/828324af_dushehra-2026.jpeg"
                                target="_blank"
                                rel="noreferrer"
                                className="btn-secondary"
                            >
                                <i className="fa fa-download"></i> Download Flyer
                            </a>
                        </div>
                    </div>

                    {/* Right Column - Flyer */}
                    <div className="event-flyer-column">
                        <div className="flyer-wrapper">
                            <img
                                src="https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/828324af_dushehra-2026.jpeg"
                                alt="Dussehra Special: Navadha Bhakti"
                                className="event-flyer-image"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default NavadhaBhakti;
